module.exports = __webpack_public_path__ + "static/img/h4.0ddda44a.jpg";